import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ExpertsSection } from './components/ExpertsSection';
import { CategoriesSection } from './components/CategoriesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="bg-black text-white min-h-screen" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ExpertsSection data-id="element-4" />
        <CategoriesSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <PricingSection data-id="element-7" />
        <FAQSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}